import { Component } from '@angular/core';

@Component({
  selector: 'app-pdf-image-content',
  imports: [],
  templateUrl: './pdf-image-content.component.html',
  styleUrl: './pdf-image-content.component.css'
})
export class PdfImageContentComponent {

}
